import { assign } from 'lodash';
import LocalTypes from '../../types/mixins/Loader';
import { isCancel, isResponseError } from '@jobstairs/axios-api-service';

const getDefaultState = () => {
    return {
        errorMessage: '',
        hasError: false,
        loading: false,
    };
};

/**
 * This function is to be called in a load Action, it simply wraps some function call
 * in a try/catch block that sets the appropriate error and loading flags/messages correctly.
 * @param commit vuex commit function
 * @param loadFunction to be executed in try/catch block
 */
export async function loadWrap(commit, loadFunction) {
    try {
        commit(LocalTypes.mutations.RESET_BASE_STATE);
        commit(LocalTypes.mutations.SET_LOADING, true);
        await loadFunction();
        commit(LocalTypes.mutations.SET_LOADING, false);
    } catch (err) {
        let tmp = err;
        if (isCancel(err)) {
            return;
        }
        if (isResponseError(err)) {
            tmp = { message: `${err.response.status}` };
        }
        commit(LocalTypes.mutations.SET_ERROR, tmp);
        commit(LocalTypes.mutations.SET_LOADING, false);
    }
}

export default () => {
    return {
        namespaced: true,
        state: getDefaultState(),
        getters: {},
        actions: {},
        mutations: {
            [LocalTypes.mutations.SET_LOADING]: (state, loading) => {
                state.loading = loading;
            },
            [LocalTypes.mutations.SET_ERROR_MESSAGE]: (state, errorMessage) => {
                state.errorMessage = errorMessage;
            },
            [LocalTypes.mutations.SET_HAS_ERROR]: (state, hasError) => {
                state.hasError = hasError;
            },
            [LocalTypes.mutations.SET_ERROR]: (state, error) => {
                state.hasError = true;
                state.errorMessage = error.message;
            },
            [LocalTypes.mutations.RESET_BASE_STATE]: (state) => {
                assign(state, getDefaultState());
            },
        },
    };
};
